import { render, staticRenderFns } from "./LaborHero.vue?vue&type=template&id=0090fef8&scoped=true&"
import script from "./LaborHero.vue?vue&type=script&lang=js&"
export * from "./LaborHero.vue?vue&type=script&lang=js&"
import style0 from "./LaborHero.vue?vue&type=style&index=0&id=0090fef8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0090fef8",
  null
  
)

export default component.exports